import React from "react";
import Box from "@material-ui/core/Box";
import {makeStyles} from '@material-ui/core/styles';
import {FooterStyles} from '../styles/dashboard';
import {IconButton} from "@material-ui/core";
import ForumIcon from '@material-ui/icons/Forum';
import MessageModal from "../containers/Dashboard/modals/Message";
import * as actions from "../store/actions";
import {connect} from "react-redux";
import MessageSuccessModal from "../containers/Dashboard/modals/MessageSuccess";


const useStyles = makeStyles(FooterStyles);

const Support = (props) => {
    const classes = useStyles();
    const [messageModal, setMessageModal] = React.useState(false);

    return (
        <React.Fragment>
            <Box className={classes.supportPanel} display="flex" alignItems="flex-end" justifycontent="flex-end">
                <IconButton style={{height: "60px", width: "60px", padding: "15px", backgroundColor: "#00AEEF"}} onClick={props.onOpen}>
                    <ForumIcon/>
                </IconButton>
            </Box>
            <MessageModal open={props.messages.isOpen}
                          handleClose={props.onClose}
                          onSuccess={ ()=>{setMessageModal(true)}}
                          />
                          <MessageSuccessModal open={messageModal} handleClose={()=>{setMessageModal(false)}} />

        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        messages: state.messages
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onOpen: () => dispatch(actions.openMessageModal()),
        onClose: () => dispatch(actions.setOpenMessagesModal(false))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Support);
